import { Component, computed, inject, input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { MenuModule } from 'primeng/menu';
import { KeycloakService } from '@shared/services/api';
import { ButtonModule } from 'primeng/button';
import { ExtendedMenuItem } from '@shared/models';
import { DateClockComponent } from '@winexist/ngp';

@Component({
	selector: 'app-topbar',
	standalone: true,
	imports: [
		RouterModule,
		CommonModule,
		StyleClassModule,
		AppConfigurator,
		MenuModule,
		ButtonModule,
		MenuModule,
		DateClockComponent
	],
	template: ` <div class="layout-topbar !shadow-md !bg-white !h-[4.5rem]">
		<div class="layout-topbar-logo-container">
            <button
                type="button"
                aria-label="Toggle menu"
                class="layout-menu-button layout-topbar-action menu-date-frame-button !text-slate-900"
                [class.is-active]="menuButtonActive()"
                (click)="layoutService.onMenuToggle()">
                <i class="pi pi-bars"></i>
            </button>
        </div>

		<div class="portal-title">PAYROLL</div>

		<div class="layout-topbar-actions">
			<div class="layout-config-menu">
				<app-configurator />

				<!-- <p-menu #menu [model]="switchOptions()" [popup]="true" />
				<p-button (click)="menu.toggle($event)" styleClass="flex align-items-center">
					<span class="text-lg font-semibold">HR Portal</span>
					<span class="material-icons text-lg"> swap_vert </span>
				</p-button> -->
				<div class="flex items-center gap-2">
					<div class="flex flex-col border-r pr-3">
						<span class="text-gray-400">Welcome back,</span>
						<span class="font-bold">{{ authService.currentUser()?.name ?? '' }}</span>
					</div>
					<ngp-date-clock />
				</div>
			</div>
		</div>
	</div>`
})
export class AppTopbar {
    switchOptions = input<ExtendedMenuItem[]>([]);

    layoutService = inject(LayoutService);
    authService = inject(KeycloakService);

    items!: MenuItem[];

    constructor() {}

    menuButtonActive = computed(() => {
        const state = this.layoutService.layoutState();
        const config = this.layoutService.layoutConfig();

        if (config.menuMode === 'overlay') {
            return !!state.overlayMenuActive;
        }

        if (this.layoutService.isDesktop()) {
            return !state.staticMenuDesktopInactive;
        }

        return !!state.staticMenuMobileActive;
        });

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }
}
